import { useTranslation } from 'react-i18next';
import ContentContainer from '../../../../templates/Content/ContentContainer';
import OrderStatusList from './OrderStatusList';

const OrderStatusPage = () => {
  const { t } = useTranslation();

  return (
    <ContentContainer title={t('orderStatus')}>
      <OrderStatusList />
    </ContentContainer>
  );
};

export default OrderStatusPage;
